/**
 * Sitio público solamente: analytics, SEO JSON-LD, consent y trackers.
 * No monta nada en /admin, /dashboard ni rutas de utilidad del shell admin —
 * menos JS, menos hooks y sin competir con /api/admin/* por conexión HTTP/2.
 */

import { ArgentinaProvinceAnalytics } from "@/components/analytics/ArgentinaProvinceAnalytics";
import { GoogleAnalyticsPageview } from "@/components/analytics/GoogleAnalyticsPageview";
import { PostHogEngagementTracker } from "@/components/analytics/PostHogEngagementTracker";
import { PostHogPageview } from "@/components/analytics/PostHogPageview";
import { PostHogTrackingVerification } from "@/components/analytics/PostHogTrackingVerification";
import { ProvinceConversionTracker } from "@/components/analytics/ProvinceConversionTracker";
import { GeoSimToolbarHost } from "@/components/dev/GeoSimToolbarHost";
import { PublicSiteCookieConsent } from "@/components/PublicSiteCookieConsent";
import { StructuredData } from "@/components/StructuredData";
import { isAdminShellPath } from "@/lib/geoConsentRoutes";
import { useLocation } from "react-router-dom";

export function PublicSiteShell() {
  const { pathname } = useLocation();
  if (isAdminShellPath(pathname)) return null;

  return (
    <>
      <ArgentinaProvinceAnalytics />
      <ProvinceConversionTracker />
      <StructuredData />
      <PostHogPageview />
      <PostHogEngagementTracker />
      <GoogleAnalyticsPageview />
      <PublicSiteCookieConsent />
      <PostHogTrackingVerification />
      {/* Toolbar geo-sim: lazy + role-gated; edge override real */}
      <GeoSimToolbarHost />
    </>
  );
}
